/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import styles from './Buttons.module.css';

/*****************************************
 * * CREATE COMPONENT
 *****************************************/
// input with number
class NumberInput extends Component {
  obj = this.props.obj;
  state = {
    value: this.obj.value,
  };

  // must be arrow or set inside JSX:
  // onChange={e => this.onInputChange(e)}
  onInputChange = event => {
    this.setState({ value: event.target.value });
    // can't use state here since may not be updated yet
    this.props.onChange(event.target.value);
  };

  render() {
    // const value = this.obj.value;
    return (
      <div className={styles.inputContainer}>
        <label className={styles.label} htmlFor={this.obj.label}>
          {this.obj.label}
        </label>
        <input
          id={this.obj.label} 
          className={`${styles.input} ${styles.sized} ${styles.number}`}
          type="number"
          value={this.state.value}
          min={this.obj.min}
          max={this.obj.max}
          step={this.obj.step}
          onChange={this.onInputChange}
          // dataToolTip={this.props.dataToolTip}
        />
      </div>
    );
  }
}

export default NumberInput;
